import { render, staticRenderFns } from "./TrainingPage.vue?vue&type=template&id=71b56854&scoped=true&"
import script from "./TrainingPage.vue?vue&type=script&lang=js&"
export * from "./TrainingPage.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPage.vue?vue&type=style&index=0&id=71b56854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b56854",
  null
  
)

export default component.exports